export default "__VITE_ASSET__Dk3NZEP0__"